const SYNC_GRACE_PERIOD_MS = 10 * 60 * 1000;

// Radar returns 403 on every endpoint until a contact has synced to it. Right
// after a contact is turned on for monitoring, treat a 403 as "still
// syncing" for a short grace period rather than as a real error.
export function isLikelyStillSyncing(isMonitoredSince: string | null): boolean {
  if (!isMonitoredSince) return false;
  return (
    Date.now() - new Date(isMonitoredSince).getTime() < SYNC_GRACE_PERIOD_MS
  );
}
